angular.module('impactx.autocompleteselection', []);